import vapi from '../../../javascript/frontend/api/vapi';
import vahoy from '../../../javascript/vahoy';
import preparePitchedEntitiesForSubmission from './pitched_entity';

// Submit a pitch to the backend. The backend determines value of "draft," and whether to schedule
// (for free users within 2 hours of publication), or send immediately (for pro users).
const completePitch = async (
  sourceRequestId,
  pitchId,
  pitchText,
  pitchPublicizable,
  promoEntities,
  attachedFileUploads,
) => {
  const pitchAttributes = {
    attachments_attributes: attachedFileUploads,
    // draft: false, // Backend determines
    id: pitchId,
    pitch: pitchText,
    content_format: 'html',
    pitched_entities: await preparePitchedEntitiesForSubmission(promoEntities),
    pitch_publicizable: pitchPublicizable,
    source_request_id: sourceRequestId,
  };

  const response = await vapi.updatePitch(pitchAttributes);
  vahoy.track('PitchForm#submitPitch');
  return response;
};

export default completePitch;
